import { createApp } from 'vue'
import App from './App.vue'
import './assets/styles/icon/iconfont.css'
import VueGridLayout from 'vue-grid-layout';
import router from "./router"
import scroll  from 'vue-seamless-scroll'
import store from './store'
import axios from './api'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'





const app =createApp(App)
app.use(VueGridLayout)
app.use(router)
app.use(scroll)
app.use(store)
app.provide('$axios', axios)
app.use(ElementPlus, {
    locale: zhCn,
})
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.mount('#app')

